/* 🤖 this file was generated by svg-to-ts */
export const mgcIconCrutchFilled: {
  name: 'crutch-filled';
  data: string;
} = {
  name: 'crutch-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.2 2.058a5.739 5.739 0 0 0-1.88.582c-1.691.85-2.856 2.403-3.225 4.3-.096.49-.123 2.655-.039 3.06.237 1.141 1.285 1.999 2.444 1.999 1.063 0 2.048-.726 2.388-1.759.076-.232.088-.382.109-1.4l.023-1.14.111-.189a.99.99 0 0 1 1.57-.212c.322.322.299-.177.3 6.498 0 6.639-.016 6.238.288 6.842a2.523 2.523 0 0 0 2.211 1.36c1.073 0 2.06-.735 2.391-1.779l.089-.28v-6.3c0-5.774-.006-6.33-.068-6.66a6.168 6.168 0 0 0-1.406-2.935c-.868-.999-2.135-1.712-3.465-1.948-.489-.087-1.381-.106-1.841-.039"/></svg>`
};
